<template>
  <div v-if="!autoImageFormat">
    <div
      class="text-sm flex-1 py-4 px-2.5 opacity-70 text-white flex items-center justify-between"
      :class="{
        ' !opacity-100': hover
      }"
    >
      <div
        class="flex justify-between items-center w-full"
        @mousemove="() => (hover = true)"
        @mouseleave="() => (hover = false)"
        @click.stop="() => showImgFormatArr()"
      >
        <span>图片输出格式</span>
        <div v-if="true" class="cursor-pointer">
          <icon
            icon="arrow-down.svg"
            :width="14"
            :height="14"
            fill="none"
            :class="{ '-rotate-90': !showImgFormat }"
          />
        </div>
      </div>
    </div>
    <div v-if="showImgFormat" class="!-mt-[6px] rounded-2xl py-1 bg-black-card">
      <AttrSelect
        label="图片输出格式"
        :options="typeOptions"
        :value="imgFormat"
        @change="changeImgFormat"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType, ref, computed } from 'vue';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { Shape } from '@/services/shape';
import { IMAGE_FORMATS } from '@/resources/image-format';
import { GlobalConfig } from '@/services/gloabl.config';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});
const watchfaceStore = useWatchfaceStore();
const watchImageFormat = computed(
  () => watchfaceStore.$state.description?.imageFormat
);

const imgFormat = computed(
  () => props.shape?.attrs.format ?? watchImageFormat.value
);

const showImgFormat = computed(() => !!props.shape.attrs.showImgFormat);
const hover = ref(false);

const showImgFormatArr = async () => {
  props.shape.setAttrs({ showImgFormat: !showImgFormat.value });
};

const changeImgFormat = (val: string | number | boolean | undefined) => {
  val && props.shape?.setAttrs({ format: val.toString() as 'indexed8' });
};

const typeOptions = IMAGE_FORMATS.map((item) => {
  return {
    label: item,
    value: item
  };
});

const autoImageFormat = computed(() => GlobalConfig.autoChooseImageFormat);
</script>

<style lang="less" scoped></style>
